import React from "react";
import { graphql } from "gatsby";
import Layout from "../../components/layout/layout";

import Helmet from "react-helmet";

import FilterBar from "../../components/browser/filter-bar";
import PageContainer from "../../components/layout/page-container";
import PageSection from "../../components/layout/page-section";
import PerformancesList from "../../components/performances/performances-list";

class PerformancesForArtistPage extends React.Component {
  constructor({ data, pageContext }) {
    super();

    this.data = data;
    this.pageContext = pageContext;
    this.artistName = pageContext.artistName;
  }

  render() {
    const performances = (this.data.allPerformancesJson) ?
                          this.data.allPerformancesJson : null;
    
    return (
      <Layout>
        <PageContainer
          bottomPadding="lg"
        >
          <Helmet>
            <title>{`${this.artistName} – Year`}</title>
          </Helmet>

          <PageSection background="dark-accent">
            <h1 className="page-title">Performances by {this.artistName}</h1>
          </PageSection>

          {(performances) ? (
            <PageSection topPadding="md">
              <PerformancesList performances={performances} 
                                artists={this.data.allArtistsJson}
                                venues={this.data.allVenuesJson}
                                grouping='year' />
              <FilterBar filterSet="performances" currentFilter="artist" />
            </PageSection>
          ) : null}
        </PageContainer>
      </Layout>
    )
  }
}

export default PerformancesForArtistPage;

export const query = graphql`
  query PerformancesForArtistQuery($artistReference: String!) {
    allPerformancesJson(
      filter: {artists: {eq: $artistReference}, reviewed: {eq: true}},
      sort: {fields: [dates], order: ASC}) {
      edges {
        node {
          dates
          artists
          description
          venue
        }
      }
    },
    allArtistsJson {
      edges {
        node {
          reference
          canonical_name
        }
      }
    },
    allVenuesJson {
      edges {
        node {
          reference
          canonical_name
        }
      }
    }
  }
`;
